// @flow
import {
    CHANGE_SELECTED_DAY,
    CHANGE_ZOOM_LEVEL,
    CHANGE_EVENTS_CURRENT_DAY,
    PAGE_READY,
    RECEIVE_EVENTS
} from './constants';
import type { Data, Day, IdType, State, ZoomLevel } from './types';

import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

const initialState = fromJS({});

export const actionHandler = {
    // $FlowFixMe
    [CHANGE_SELECTED_DAY]: (state: State, { payload: { id, day } }: { payload: { id: IdType, day: Day } }) =>
        state.setIn([id, 'selectedDay'], day).setIn([id, 'hasLoadedDayData'], false),

    // $FlowFixMe
    [CHANGE_ZOOM_LEVEL]: (
        state: State,
        { payload: { id, zoomLevel } }: { payload: { id: IdType, zoomLevel: ZoomLevel } }
    ) => state.setIn([id, 'zoomLevel'], zoomLevel),
    // $FlowFixMe
    [CHANGE_EVENTS_CURRENT_DAY]: (state: State, { payload: { id, day } }: { payload: { id: IdType, day: Day } }) =>
        state.setIn([id, 'eventsCurrentDay'], day),
    // $FlowFixMe
    [PAGE_READY]: (state: State, { payload: { id } }: { payload: { id: IdType } }) =>
        state.setIn([id, 'hasLoaded'], true),

    [RECEIVE_EVENTS]: (
        state: State,
        { payload: { data, day, id } }: { payload: { id: IdType, day: Day, data: Data } }
    ) => state.setIn([id, 'events', day], fromJS(data)).setIn([id, 'hasLoadedDayData'], true)
};

// $FlowFixMe
export default handleActions(actionHandler, initialState);



// WEBPACK FOOTER //
// ./src/core/state/products/contact-sensor/index.js